import React, { useCallback } from 'react';
import { Row, Select } from 'antd';
import PropTypes from 'prop-types';

const options = [
  {
    value: 'showSelected',
    label: 'Show Selected',
  },
  {
    value: 'showAll',
    label: 'Show All',
  },
];

export default function DropdownFieldPdfDisplaySelect({
  isV3Form,
  configProps = {},
  setConfigProps,
}) {
  const { pdfDisplay = 'showSelected', style = 'dropdown' } = configProps;
  const supportsPdfDisplay = style === 'radio' || style === 'checkbox';

  const onChange = useCallback((value) => {
    setConfigProps({
      ...configProps,
      pdfDisplay: value,
    });
  }, [configProps, setConfigProps]);

  if (!isV3Form || !supportsPdfDisplay) return null;

  return (
    <>
      <Row style={{ marginTop: 15 }}>
        PDF Display:
      </Row>
      <Row style={{ marginTop: 5 }}>
        <Select
          style={{ width: 350 }}
          options={options}
          value={pdfDisplay}
          optionFilterProp="label"
          onChange={onChange}
        />
      </Row>
    </>
  );
}

DropdownFieldPdfDisplaySelect.propTypes = {
  isV3Form: PropTypes.bool,
  configProps: PropTypes.shape({}),
  setConfigProps: PropTypes.func.isRequired,
};

DropdownFieldPdfDisplaySelect.defaultProps = {
  isV3Form: false,
  configProps: {},
};
